// RTL Unicode ranges: Arabic, Hebrew, Syriac, Thaana, N'Ko, and extended Arabic
const RTL_REGEX =
  /[\u0590-\u05FF\u0600-\u06FF\u0700-\u074F\u0750-\u077F\u0780-\u07BF\u08A0-\u08FF]/;

export function detectLanguageAndDirection(text?: string | null): {
  direction: 'rtl' | 'ltr';
} {
  if (!text) return { direction: 'ltr' };
  return { direction: RTL_REGEX.test(text) ? 'rtl' : 'ltr' };
}
